// extracted by mini-css-extract-plugin
export default {"pageGroupWrapper":"JshATs","pageGroup":"fcNEqv"};